/** These are used only in warnings to designate if marine or land type warning. Used on warnings pages */
export enum WarningsType {
  Land = 'land',
  Marine = 'marine',
}

export enum MarkerTypeCodeGenerated {
  Warning = 'warning',
  MarkerV2 = 'markerV2',
}

export enum MarkerTypeGeneral {
  BBQ = 'bbq',
  Coastal = 'coastal',
  HighSeas = 'high-seas',
  Park = 'park',
  Recreation = 'recreation',
  Tidal = 'tidal',
  National = 'national',
  Ski = 'ski',
  Urban = 'urban',
  SimpleText = 'simpleText',
}

export enum MarkerTypeTraffic {
  Incident = 'incident',
  TrafficCamera = 'traffic-camera',
}

export const MarkerTypeWaterActivity = {
  Boating: 'boating',
  Surfing: 'surfing',
  Paddleboarding: 'paddleboarding',
  Kayak: 'kayak',
} as const;

export enum MarkerTypeWeatherStation {
  Fenz = 'fenz',
  Coastguard = 'coastguard',
  Council = 'council',
  Local = 'local',
  Metservice = 'metservice',
  Nzta = 'nzta',
}

export enum MarkerTypeMountain {
  Mountain = 'mountain',
  // MountainWalk = 'mountain-walk',
}
